import { render, staticRenderFns } from "./TituloPermissao.vue?vue&type=template&id=a40c83ae&"
import script from "./TituloPermissao.vue?vue&type=script&lang=js&"
export * from "./TituloPermissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports